import { useTheme } from "@emotion/react";
import { Box, useMediaQuery } from "@mui/material";
import { getFileCategory } from "utilities/index";

const DocumentCategoryIcon = ({ row, value, onClick }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    // console.log(row,cell.value,"rc")
    return <Box width={isSmallScreen ? 35 : 40} onClick={() => {
        onClick && onClick()
    }} height={isSmallScreen ? 35 : 40} 
    // bgcolor={theme?.palette?.customColors?.indigo100}
     borderRadius={"4px"} display={"flex"} alignItems="center" justifyContent={"center"} sx={{
        // minWidth: isSmallScreen ? 35 : 40,
        // minHeight: isSmallScreen ? 35 : 40,
        // maxWidth: isSmallScreen ? 35 : 40,
        // maxHeight: isSmallScreen ? 35 : 40,
        ...(onClick ? { cursor: 'pointer' } : {})
    }}>
        <img src={getFileCategory(value)} width={isSmallScreen ? 35 : 40} height={isSmallScreen ? 35 : 40} />
    </Box>
}

export default DocumentCategoryIcon;